import { AxiosResponse } from 'axios'
import { URLS } from '@assets/environment/urls'
import { StartHistoryResult, UpdateWorkoutExercise } from '@entities/training/types/history'
import { authAxios } from '@shared/api/auth-instance'
import { WorkoutHistory } from '@entities/training'

export class WorkoutHistoryProxy {
	static BASE_URL: string = URLS.WORKOUT + 'workouts_history/'

	static startTraining = async (
		trainingId: number | string
	): Promise<StartHistoryResult | null> => {
		try {
			const response: AxiosResponse<StartHistoryResult> =
				await authAxios.post<StartHistoryResult>(this.BASE_URL + `${trainingId}/start`)
			console.log('training started', response)
			return response.data
		} catch (e) {
			console.log(e)
			return null
		}
	}

	static updateTrainingInfo = async (
		idWorkoutHistory: number,
		exerciseOrder: number,
		params: UpdateWorkoutExercise
	): Promise<boolean> => {
		try {
			const response = await authAxios.patch(
				this.BASE_URL + `${idWorkoutHistory}/exercise/${exerciseOrder}`,
				params
			)
			console.log('WORKOUT UPDATED', response)
			return true
		} catch (e) {
			console.log(e)
			return false
		}
	}

	static finishTraining = async (idWorkoutHistory: number, forceSkip?: boolean) => {
		try {
			const response = await authAxios.post(
				`${this.BASE_URL}${idWorkoutHistory}/complete`,
				forceSkip && {
					force_skip: forceSkip,
				}
			)
			console.log(response)
			return true
		} catch (e) {
			console.log(e)
			return false
		}
	}

	static getWorkoutHistoryById = async (id: number): Promise<WorkoutHistory | null> => {
		try {
			const response: AxiosResponse<WorkoutHistory> = await authAxios.get<WorkoutHistory>(
				this.BASE_URL + `${id}`
			)
			return response.data
		} catch (e: unknown) {
			console.log(e)
			return null
		}
	}
}
